<div class="details-page">
  <!-- Content area with light purple background -->
  <div class="details-content">
    <div class="breadcrumb-container">
      <!-- this is for when we are coming from Location results page -->
      <div *ngIf="providerDetails === null" class="search-breadcrumb">
        <div [class]="locale === 'es-US' ? 'search-breadcrumb-item-1-spanish' : 'search-breadcrumb-item-1'" style="text-decoration: underline; cursor: pointer;" (click)="clearLocationSearch()">
          {{breadcrumb1}}
        </div>
        <div class="search-breadcrumb-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
            <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="search-breadcrumb-item" style="text-decoration: underline; cursor: pointer" (click)="returnToSearchResults()">
          {{breadcrumb2}}
        </div> 
        <div class="search-breadcrumb-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
            <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="search-breadcrumb-name">
          {{ locationName.length > 12 ? (locationName.substring(0, 12) + '...') : locationName }}
        </div> 
      </div>
      <!-- this is for landing from prov details page  -->
      <div *ngIf="providerDetails !== null" class="search-breadcrumb">
        <div [class]="locale === 'es-US' ? 'search-breadcrumb-item-1-spanish' : 'search-breadcrumb-item-1'" style="text-decoration: underline; cursor: pointer;" (click)="clearProviderSearch()">
          {{provBreadcrumb1}}
        </div>
        <div class="search-breadcrumb-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
            <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="search-breadcrumb-item" style="text-decoration: underline; cursor: pointer" (click)="backToProviderSearchResults()">
          {{provBreadcrumb2}}
        </div> 
        <div class="search-breadcrumb-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
            <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="search-breadcrumb-name" style="text-decoration: underline; cursor: pointer" (click)="(backToProviderDetails())">
          {{ providerDetails.providerName.length > 5 ? (providerDetails.providerName.substring(0, 5) + '...') : providerDetails.providerName }}
        </div> 
        <div class="search-breadcrumb-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
            <path d="M0.499999 12.5L6.5 6.5L0.5 0.5" stroke="#33006F" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="search-breadcrumb-name">
          {{ locationName.length > 5 ? (locationName.substring(0, 5) + '...') : locationName }}
        </div> 
      </div>
    </div>
    

    <!-- Location image -->
    <div class="location-image" 
      [style.background-image]="photo ? 'url(' + photo + ')' : 'url(/default-location-img.jpg)'"
      [style.background-position]="'right center'">
    </div>

    <!-- Info card -->
    <div class="info-card">
      <!-- Location name -->
      <h2 class="location-name">{{ locationName }}</h2>

      <!-- Distance -->
      <div *ngIf="distance !== null && distance !== ''" class="distance-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 11 12" fill="none">
          <path d="M10.9563 0L6.47199 11.1046L4.93895 6.2119L-2.03945e-05 4.83525L10.9563 0Z" fill="#959595"/>
        </svg>
        <span class="distance">{{ distance }}</span>
      </div>

      <!-- Address -->
      <div class="info-row">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 6 10" fill="none">
          <ellipse cx="3.00471" cy="2.76119" rx="3.00471" ry="2.76119" fill="#959595"/>
          <line x1="2.95605" y1="4.41785" x2="2.95605" y2="9.94024" stroke="#959595" stroke-width="1.10448"/>
        </svg>
        <div class="address">
          <p>{{ addressLine1 }}</p>
          <p>{{ addressLine2 }}</p>
        </div>
      </div>

      <!-- Phone -->
      <div class="info-row" *ngIf="phone != null && phone != ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 11 10" fill="none">
          <path d="M7.45017 9.112C5.70207 9.10981 4.02621 8.4371 2.79012 7.2414C1.55402 6.0457 0.858589 4.42461 0.856323 2.73364C0.856323 2.22834 1.06383 1.74374 1.4332 1.38644C1.80257 1.02914 2.30355 0.828416 2.82591 0.828416C2.93653 0.827601 3.04696 0.837312 3.15561 0.857409C3.26064 0.872444 3.3639 0.897414 3.46389 0.931961C3.53422 0.95583 3.59688 0.997043 3.64569 1.05152C3.69451 1.106 3.72777 1.17187 3.7422 1.2426L4.3288 3.72767C4.34461 3.79512 4.3427 3.86534 4.32326 3.9319C4.30381 3.99845 4.26744 4.05924 4.21747 4.10872C4.16181 4.1667 4.15753 4.17084 3.63088 4.43592C4.05262 5.3309 4.79259 6.04962 5.71607 6.46125C5.99438 5.94767 5.99867 5.94353 6.05861 5.88969C6.10975 5.84135 6.17259 5.80617 6.2414 5.78736C6.31021 5.76855 6.38279 5.7667 6.45253 5.782L9.02156 6.34942C9.09234 6.36531 9.15777 6.39836 9.2117 6.44545C9.26564 6.49255 9.30629 6.55215 9.32984 6.61864C9.36598 6.71695 9.3932 6.81811 9.41119 6.92099C9.42843 7.02509 9.43702 7.13035 9.43688 7.23577C9.42899 7.7389 9.21565 8.21859 8.84343 8.57011C8.47121 8.92163 7.97034 9.11643 7.45017 9.112V9.112Z" fill="#888888"/>
        </svg>
        <p class="phone">{{ phone }}</p>
      </div>

      <!-- Get directions link -->
       <div class="info-row">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
          <path d="M4.50996 0.644287L0.644287 2.57712V10.9527L4.50996 9.01991M4.50996 0.644287V9.01991M4.50996 0.644287L8.37563 2.57712M4.50996 9.01991L8.37563 10.9527M8.37563 10.9527L12.2413 9.66419V1.28857L8.37563 2.57712M8.37563 10.9527V2.57712" stroke="#959595" stroke-width="1.28856" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <a href="#" class="directions-link" (click)="getDirections($event)">{{getDirectionsText}}</a>
      </div>

      <!-- Hours section -->
      <div *ngIf="openHours && openHours.length > 0" class="hours-section">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 17 17" fill="none">
          <path d="M8.49996 1.41675C7.09901 1.41675 5.72952 1.83218 4.56467 2.6105C3.39983 3.38883 2.49194 4.4951 1.95582 5.78941C1.4197 7.08372 1.27942 8.50794 1.55273 9.88197C1.82605 11.256 2.50067 12.5181 3.49129 13.5088C4.48191 14.4994 5.74404 15.174 7.11807 15.4473C8.49211 15.7206 9.91633 15.5803 11.2106 15.0442C12.5049 14.5081 13.6112 13.6002 14.3895 12.4354C15.1679 11.2705 15.5833 9.90103 15.5833 8.50008C15.5811 6.62212 14.8342 4.8217 13.5063 3.49378C12.1783 2.16586 10.3779 1.4189 8.49996 1.41675ZM8.49996 14.1667C7.3792 14.1667 6.28361 13.8344 5.35173 13.2117C4.41985 12.5891 3.69354 11.7041 3.26465 10.6686C2.83575 9.63317 2.72353 8.4938 2.94218 7.39457C3.16083 6.29534 3.70053 5.28564 4.49302 4.49314C5.28552 3.70065 6.29523 3.16095 7.39445 2.9423C8.49368 2.72365 9.63305 2.83587 10.6685 3.26476C11.704 3.69366 12.589 4.41997 13.2116 5.35185C13.8343 6.28373 14.1666 7.37932 14.1666 8.50008C14.1649 10.0024 13.5673 11.4428 12.505 12.5051C11.4427 13.5675 10.0023 14.165 8.49996 14.1667ZM9.2083 8.32229V4.95841C9.2083 4.77055 9.13367 4.59039 9.00083 4.45755C8.86799 4.32471 8.68782 4.25008 8.49996 4.25008C8.3121 4.25008 8.13193 4.32471 7.9991 4.45755C7.86626 4.59039 7.79163 4.77055 7.79163 4.95841V8.50008C7.79173 8.61674 7.82047 8.73158 7.87533 8.83453L8.93783 10.817C9.02653 10.9827 9.17741 11.1063 9.35727 11.1608C9.53714 11.2152 9.73125 11.1959 9.89692 11.1072C10.0626 11.0185 10.1862 10.8676 10.2406 10.6878C10.2951 10.5079 10.2758 10.3138 10.1871 10.1481L9.2083 8.32229Z" fill="#888888"/>
        </svg>
        <div class="hours-text">
          <ng-container *ngFor="let hourType of getUniqueHourTypes(); let isLast = last">
            <p><strong>{{ hourType }}:</strong></p>
            <ng-container *ngFor="let hour of getHoursByType(hourType)">
              <p>{{ hour.days }}: {{ hour.openHours }}</p>
              <p *ngIf="hour.notes">{{ hour.notes }}</p>
            </ng-container>
            <p *ngIf="!isLast">&nbsp;</p>
          </ng-container>
        </div>
      </div>

      <!-- Map image -->
      <!-- <div class="map-image"></div> -->

      <!-- Conditional bottom section -->
      <!-- Urgent Care: Reserve My Spot button -->
      <button *ngIf="isUrgentCare" class="reserve-button" (click)="onReserveMySpot()">
        {{reserveBtnText}}
      </button>

      <!-- Non-Urgent Care: Providers section -->
      <div *ngIf="!isUrgentCare && providers != null && providers.length > 0" class="providers-section">
        <h3 class="providers-title">{{providersLabel}}</h3>

        <!-- Provider cards -->
        <div class="provider-card" *ngFor="let provider of providers" (click)="viewProvider(provider)">
          <div class="provider-photo" 
            [style.background-image]="provider.photoUrl && provider.photoUrl !== 'assets/images/provider-placeholder.jpg' ? 'url(' + provider.photoUrl + ')' : 'url(vudprovider.png)'">
          </div>
          <div class="provider-info">
            <h4 class="provider-name">{{ provider.providerName }}</h4>
            <p class="provider-specialty">{{ provider.specialties }}</p>
          </div>
          <div *ngIf="provider.nextAvailability != null" class="provider-availability">
            <p class="availability-label">{{asSoonAsText}}</p>
            <p class="availability-time">{{ provider.nextAvailability }}</p>
          </div>
          <button *ngIf="provider.nextAvailability != null || (provider.openScheduling != null && provider.openScheduling == true && provider.departmentId != null)" class="schedule-button" (click)="onScheduleButtonClicked(provider); $event.stopPropagation()">
            {{scheduleBtnText}}
          </button>
            <button *ngIf="provider.nextAvailability == null && (provider.openScheduling == null || provider.openScheduling != true || provider.departmentId == null)" class="schedule-button" (click)="onCallPhone(provider); $event.stopPropagation()">
            {{callBtnText}}
            </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Home indicator -->
  <div class="home-indicator"></div>
</div>
